import script from "./AdminProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProducts.vue?vue&type=script&setup=true&lang=js"

import "./AdminProducts.vue?vue&type=style&index=0&id=f4bf3948&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4bf3948"]])

export default __exports__